import React from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Divider,
} from '@mui/material';
import { Monitor } from '@mui/icons-material';
import LoginButton from './LoginButton';
import { useAuth } from '../../context/AuthContext';

const LoginPage: React.FC = () => {
  const { isLoading, authError } = useAuth();

  if (isLoading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
        sx={{ background: '#1976d2' }}
      >
        <Typography variant="h6" color="white">
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      minHeight: '100vh',
      background: '#1976d2',
      display: 'flex',
      alignItems: 'center',
      py: 4
    }}>
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4,
          alignItems: 'center'
        }}>
          {/* Left Side - Info */}
          <Box sx={{ 
            flex: 1, 
            color: 'white',
            textAlign: { xs: 'center', md: 'left' }
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
              <Monitor sx={{ fontSize: 48 }} />
              <Typography variant="h3" component="h1" fontWeight="bold">
                Regulations Monitoring
              </Typography>
            </Box>
            
            <Typography variant="h5" sx={{ mb: 4, opacity: 0.9 }}>
              Automated regulatory monitoring system
            </Typography>
          </Box>
          <Box sx={{ flex: 1, maxWidth: 500 }}>
            <Paper
              elevation={24}
              sx={{
                p: 4,
                borderRadius: 3,
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)'
              }}
            >
              <Box sx={{ textAlign: 'center', mb: 4 }}>
                <Typography variant="h4" gutterBottom color="primary" fontWeight="bold">
                  Sign In
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Sign in with Google to access the platform
                </Typography>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Box sx={{ mb: 4 }} textAlign="center">
                {
                  !authError ?
                    <LoginButton
                        variant="contained"
                        size="large"
                        fullWidth
                    />
                  : authError === 'access_denied' ?
                    <>
                      <Typography variant="body1" color="error">
                        Your email is not authorized to access this platform<br/>
                        Contact the person who shared the platform link with you
                      </Typography>
                    </>
                  :
                    <>
                      <Typography variant="body1" color="error">
                        Something went wrong<br/>
                        Please contact application administrator.
                      </Typography>
                    </>
                }
              </Box>
            </Paper>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default LoginPage; 